import { useApiClient } from "./useApiClient";
import { useResource, type ResourceState } from "./useResource";
import { ClusterApi } from "../api/cluster";
import type { ClusterDetail } from "../api/types";

/** Fetch cluster overview (OpenDeskCluster CR). */
export function useCluster(): ResourceState<ClusterDetail> {
  const client = useApiClient();
  return useResource<ClusterDetail>(
    async () => {
      if (!client) return null;
      const res = await new ClusterApi(client).getCluster();
      return res.data ?? null;
    },
    [client],
  );
}
